export enum ContactType {
    PHONE = 'phone',
    EMAIL = 'email',
    TELEGRAM = 'telegram',
    WHATSAPP = 'whatsapp',
    X = 'x',
    YOUTUBE = 'youtube',
    INSTAGRAM = 'instagram',
    FACEBOOK = 'facebook',
    SHOPIFY = 'shopify',
    MERCADO_LIBRE = 'mercado_libre',
}
